module.exports = __webpack_public_path__ + "img/logokv.d1d207c2.png";